import React from 'react'
import InvcList from './InvcList'
import isEmpty from 'lodash/isEmpty'

export default class InvcForm extends React.Component {
  
  render() {
    if(isEmpty(this.props.invcs)
      || isEmpty(this.props.requs)
    ){
      return(<div>Не загружены данные</div>);
    }
    
    const { requs, order, addInvc, editInvc } = this.props;
    const { data } = this.props.invcs;
      
    return (
      <div>
        <InvcList
          order={order}
          invcs={data}
          requs={requs}
          addInvc={addInvc}
          editInvc={editInvc}
        />
      </div>
    )
    
  }
}



// WEBPACK FOOTER //
// ./src/components/invc/InvcForm.js